// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3H3jM","list":"BalanceDue_list__2cGZa","listRow":"BalanceDue_listRow__JRlX-","total":"BalanceDue_total__2xAcX"};